/**
 * 获取带后缀的文件名
 * /a/b/c.txt → c.txt
 */
export function getFileName(fullPath: string): string {
  if (!fullPath) return ''
  const parts = fullPath.replace(/\\/g, '/').split('/')
  return parts.pop() || ''
}

/**
 * 获取不带后缀的文件名
 * /a/b/c.txt → c
 */
export function getFileNameWithoutExt(fullPath: string): string {
  const fileName = getFileName(fullPath)
  const index = fileName.lastIndexOf('.')
  return index === -1 ? fileName : fileName.slice(0, index)
}

/**
 * 获取文件后缀（不带点）
 * c.txt → txt
 */
export function getExt(fullPath: string): string {
  const fileName = getFileName(fullPath)
  const index = fileName.lastIndexOf('.')
  return index === -1 ? '' : fileName.slice(index + 1)
}

/**
 * 获取路径（去掉文件名）
 * /a/b/c.txt → /a/b/
 * 注意：保留末尾斜杠
 */
export function getDir(fullPath: string): string {
  const normalized = fullPath.replace(/\\/g, '/')
  const idx = normalized.lastIndexOf('/')
  return idx === -1 ? '' : normalized.slice(0, idx + 1)
}

/**
 * 获取父目录路径
 * /a/b/c/ → /a/b/
 * /a/b/c.txt → /a/b/
 */
export function getParentDir(fullPath: string): string {
  let dir = getDir(fullPath)
  dir = dir.endsWith('/') ? dir.slice(0, -1) : dir
  const idx = dir.lastIndexOf('/')
  return idx === -1 ? '/' : dir.slice(0, idx + 1)
}

/**
 * 计算相对路径
 * from: /a/b/c
 * to:   /a/d/e.txt
 * → ../../d/e.txt
 */
export function relative(from: string, to: string): string {
  const normalize = (p: string) => p.replace(/\\/g, '/').split('/').filter(Boolean)

  const fromParts = normalize(from)
  const toParts = normalize(to)

  // 找共同路径前缀
  let sameIndex = 0
  while (sameIndex < fromParts.length && sameIndex < toParts.length && fromParts[sameIndex] === toParts[sameIndex]) {
    sameIndex++
  }

  // 计算需要返回多少层
  const up = fromParts.length - sameIndex
  const upParts = Array(up).fill('..')

  // 剩余部分
  const downParts = toParts.slice(sameIndex)

  return [...upParts, ...downParts].join('/') || '.'
}
